module.exports = __webpack_public_path__ + "static/media/mode-rexel-logo-ripeurs-white.e6113d6e.png";